var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main" },
    [
      _c("page-title"),
      _vm._v(" "),
      _c(
        "page-card",
        [
          _c(
            "template",
            { slot: "tab" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "page-tab",
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.active,
                    callback: function ($$v) {
                      _vm.active = $$v
                    },
                    expression: "active",
                  },
                },
                [
                  _c("el-tab-pane", { attrs: { name: "OIL" } }, [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm.active === "OIL"
                          ? _c("svg-icon", {
                              attrs: { "icon-class": "tn-oil" },
                            })
                          : _c("svg-icon", {
                              attrs: { "icon-class": "tn-oil1" },
                            }),
                        _vm._v(
                          "\n            Oil(" +
                            _vm._s(_vm.oilTotal) +
                            ")\n          "
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "GAS" } }, [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm.active === "GAS"
                          ? _c("svg-icon", {
                              attrs: { "icon-class": "tn-gas2" },
                            })
                          : _c("svg-icon", {
                              attrs: { "icon-class": "tn-gas" },
                            }),
                        _vm._v(
                          "\n            Gas(" +
                            _vm._s(_vm.gasTotal) +
                            ")\n          "
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "header" }, [
            _c("div", { staticClass: "spaceBetween" }, [
              _c("span", [_vm._v("Producer Well List")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "search-input",
                      attrs: { placeholder: "Enter well name to search…" },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.getList($event)
                        },
                      },
                      model: {
                        value: _vm.searchData.nickname,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchData, "nickname", $$v)
                        },
                        expression: "searchData.nickname",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "append", size: "mini" },
                          on: { click: _vm.getList },
                          slot: "append",
                        },
                        [
                          _c("svg-icon", {
                            attrs: { "icon-class": "tn-search" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "page-table",
              staticStyle: { "margin-top": "-12px" },
              attrs: { slot: "body" },
              slot: "body",
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    stripe: "",
                    data: _vm.tableList,
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "registrationDate",
                      label: "Submission Date",
                      width: "220px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("time")(row.timestamp, "yyyy-MM-DD")
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userID",
                      label: "treasurenet Account",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "nickname", label: "Well Name" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "Operation",
                      label: "Operation",
                      width: "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toApprove(row)
                                  },
                                },
                              },
                              [_vm._v("Review")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-bottom-btn" },
                [
                  _c("pagination", {
                    attrs: {
                      total: _vm.queryParams.total,
                      page: _vm.queryParams.page,
                      limit: _vm.queryParams.pageSize,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.queryParams, "page", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.queryParams, "pageSize", $event)
                      },
                      pagination: function ($event) {
                        return _vm.getList()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }